// @flow
import React, { PureComponent } from 'react';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import { Text } from 'trpc-react-native-ui';

export default class ChangePhoneNumber extends PureComponent<Props> {
  render() {
    return <Text>New page</Text>;
  }
}

type Props = { navigation: NavigationScreenProp<NavigationRoute> };
